<template>
  <div style="overflow: auto; height: 100%" ref="fadeWhenModelOpen" v-if="profileResp && Object.keys(profileResp).length">
    <div style="height:50px;" class="comm-settings-top-nav">
      <div class="col-md-12 p-0 justify-content-start h-100">
        <nav aria-label="breadcrumb" class="h-100">
          <ol class="breadcrumb comm-settings-top-nav m-0 h-100">
            <li class="comm-icon-rtl"><back-button  v-on:click.native="handleBackNavigation(false)"></back-button></li>
            <li class="breadcrumb-item active-text-nav-bar" aria-current="page">{{selectedProfileKeyName}}</li>
            </ol>
        </nav>
      </div>
    </div>
    <div class="set-height-of-div">
    <table class="table users-basic-info-table" style="background: transparent">
      <thead style="color: #eee">
        <tr>
          <th scope="col" style="width: 20%"></th>
          <th scope="col" style="width: 80%"></th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td class="key-div">{{$t('Name')}} *</td>
          <td id="field_name" class="value-div d-flex float-left m-0" style="width:42%;margin-top:10px!important">
            <div class="w-100">
              <div class="d-inline-flex">
                <span v-show="!isMainEditting('name')" style="font-size: 16px;
    margin-inline-start: 10px;">{{profileInfo.name}}</span>
                <edit-icon @click.native="editMainField('name')"
                      v-show="!isMainEditting('name')" class="editIcon show-tags-delete">
                </edit-icon>
              </div>          
              <input
                type="text"
                id="name_value"
                class="rounded text-light comm-input-field-style align-input-field"
                v-model="keyInfo.name"
                autocomplete="off"
                style="font-size:16px"
                v-show="isMainEditting('name')"
              />
            </div>
            <div v-show="isMainEditting('name')">
              <div class="d-flex">
                <save-icon @click.native="updateCustomMetadata('name')"></save-icon>
                <cancel-icon @click.native="mainFieldKeyName =''"></cancel-icon>
              </div>
            </div>

            
          </td>
        </tr>
        <tr>
          <td class="key-div">{{$t('Load when')}}</td>
          <td id="field_load_when" class="value-div d-flex m-0">
            <load-type-filter v-show="reRenderPage" :selectedScreenProfileID="this.selectedId"
              :selectedProfileResp="profileResp"
             :newProfile="false" ref="loadWhenBrowserDiv"
            @fadePage="handleFadePage"></load-type-filter>
          </td>
        </tr>
        <tr>
          <td class="key-div">{{$t('Fields')}}</td>
          <td id="field_fields" class="value-div d-flex m-0" style="position: relative;bottom: 9px;">
            <div class="value-style d-inline-flex bg-transparent rounded text-light input-fields searched-metadata-display-fields">
                              <ul class="tags-display-ul p-0 w-100 m-0" style=" display: grid;">
                                <div style="display: grid;">
                                <li class="add-screens-styles" @click="enableFieldBrowser=true">
                                  <div style="margin-inline-end:10px">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" class="bi bi-plus-circle" viewBox="0 0 16 16">
                                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                                        <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
                                    </svg>
                                  </div>
                                  <div style="font-size: 15px;line-height: 55px;">{{$t('Add Field(s) to Screen profile')}}</div>
                                </li>
                                <li style="position:relative;inset-inline-end:5px">
                                  <template v-for="fieldId in keyInfo.custom_metadata_id_list">
                                    <div class="list-group-item view-tags" style="color:#EEEEEE" v-if="fieldId == 'Description'" :key="fieldId">
                                        <div class="screen-tags-name-display">
                                            <div>
                                              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-list drag-icon" viewBox="0 0 16 16">
                                                  <path fill-rule="evenodd" d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"/>
                                              </svg >
                                            </div>
                                            <div style="margin-inline-start: 5px !important" class="screens-name-styles">{{$t('Description')}}</div>
                                        </div>
                                        <div class="screen-tags-styles">
                                          <cancel-icon class="show-main-tag-delete" @click.native="removeField(fieldId)"
                                           style="float: inline-start;text-align: start;margin:8px;height:30px !important;width:30px; !important"
                                           title="Remove Field"></cancel-icon>
                                        </div>
                                    </div>
                                    <div class="list-group-item view-tags" style="color:#EEEEEE" v-else-if="fieldId == 'Catalogs'" :key="fieldId">
                                        <div class="screen-tags-name-display">
                                            <div>
                                              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-list drag-icon" viewBox="0 0 16 16">
                                                  <path fill-rule="evenodd" d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"/>
                                              </svg >
                                            </div>
                                            <div style="margin-inline-start: 5px !important" class="screens-name-styles">{{$t('Catalogs')}}</div>
                                        </div>
                                        <div class="screen-tags-styles">
                                          <cancel-icon class="show-main-tag-delete" @click.native="removeField(fieldId)"
                                           style="float: inline-start;text-align: start;margin:8px;height:30px !important;width:30px; !important"
                                           title="Remove Field"></cancel-icon>
                                        </div>
                                    </div>
                                    <div class="list-group-item view-tags" style="color:#EEEEEE" v-else-if="isFieldExists(fieldId)" :key="fieldId">
                                        <div class="screen-tags-name-display">
                                            <div>
                                              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-list drag-icon" viewBox="0 0 16 16">
                                                  <path fill-rule="evenodd" d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"/>
                                              </svg >
                                            </div>
                                            <div style="margin-inline-start: 5px !important" class="screens-name-styles">{{ getFieldNamefromId(fieldId) }}</div>
                                        </div>
                                        <div class="screen-tags-styles">
                                          <cancel-icon class="show-main-tag-delete" @click.native="removeField(fieldId)"
                                           style="float: inline-start;text-align: start;margin:8px;height:30px !important;width:30px; !important"
                                           title="Remove Field"></cancel-icon>
                                        </div>
                                    </div>
                                  </template>
                                  <div v-if='isTagsEnabled' class="w-100">
                                        <div class="list-group-item view-tags" style="color:#EEEEEE">
                                          <div class="screen-tags-name-display">
                                            <div>
                                              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-list drag-icon" viewBox="0 0 16 16">
                                                  <path fill-rule="evenodd" d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"/>
                                              </svg >
                                            </div>
                                            <div style="margin-inline-start: 5px !important" class="screens-name-styles">{{$t('Tags')}}</div>
                                          </div>
                                          <div class="screen-tags-styles">
                                            <template v-if="profileInfo.tag_display_all == true">
                                              <div :key="tagId">
                                                <div class="view-sub-tags" style="background: #393939;border: 2px solid #000 !important;">
                                                  <span>{{$t('ALL')}}</span>
                                                  <cancel-icon class="show-tags-delete" @click.native="updateTagDisplay()"
                                                  style="float: inline-end;text-align: end" title="Remove Tag"></cancel-icon>
                                                </div>
                                              </div>
                                            </template>
                                            <template v-else v-for="tagId in keyInfo.tag_id_list">
                                              <div :key="tagId">
                                                <div class="view-sub-tags" style="background:#33691e">
                                                  <span>{{getTagNamefromId(tagId)}}</span>
                                                  <cancel-icon class="show-tags-delete" @click.native="removeTagId(tagId)"
                                                  style="float: inline-end;text-align: end" title="Remove Tag"></cancel-icon>
                                                </div>
                                              </div>
                                            </template>
                                            <div class="dropdown">
                                              <div class="nav-item nav-link dropdown-toggle mr-md-2" id="bd-versions" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                                                <svg width="15" height="1.5em" viewBox="0 0 16 16" class="bi bi-three-dots more-actions-btn"  fill="#C5c0c0" xmlns="http://www.w3.org/2000/svg">
                                                  <path fill-rule="evenodd" d="M3 9.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"/>
                                                </svg>
                                              </div>
                                              <div class="dropdown-menu dropdown-menu-md-right p-0" aria-labelledby="bd-versions">
                                                    <a class="dropdown-item p-2" :class="{activeClass:profileInfo.tag_display_all == false}" @click.stop.prevent="enableTagBrowser=true;profileInfo.tag_display_all=false">
                                                      {{$t('Add specific Tag(s)')}}</a>
                                                    <a class="dropdown-item p-2" :class="{activeClass:profileInfo.tag_display_all == true}" @click.stop.prevent="updateTagDisplay()">
                                                      {{$t('Select all Tag(s)')}}</a>
                                              </div>
                                            </div>
                                          </div>
                                        <div class="screen-tags-styles">
                                          <cancel-icon class="show-main-tag-delete" @click.native="removeField('1')"
                                           style="float: inline-start;text-align: start;margin:8px;height:30px !important;width:30px; !important"
                                           title="Remove Field"></cancel-icon>
                                        </div>
                                        </div>
                                  </div>
                                </li>
                                </div>
                              </ul>
                          </div>
          </td>
        </tr>
      </tbody>
    </table>
    </div>
    <field-browser ref="fieldBrowserDiv" v-if="enableFieldBrowser" :isEditGroup="false" :browseMultiFields="true" :isScreenProfile="true"
        :selectedIds='getLoadWhenFieldIds' @close='handleFieldSelection' screenType="ScreenProfiles"></field-browser>
    <tag-browser v-if="enableTagBrowser" :isEditGroup="false" 
          :userNameIdMap='selectedTagIdNameMap'
       :selectedIds='keyInfo.tag_id_list' @close='handleTagSelection'></tag-browser>
  </div>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from "vuex"
import Utils from "../../components.utils.js";
import BackButton from "../core/backButton.vue";
import LoadTypeFilter from  "./LoadTypeFilter.vue"
import FieldBrowser from "../customMetadata/AddFieldsFromBrowser.vue"
import TagBrowser from "../tags/MultiTagBrowser.vue"
import CancelIcon from "../core/InlineCancelField.vue";
import EditIcon from "../core/InlineEditField.vue";
import SaveIcon from "../core/InlineSaveField.vue";
import {NotifierConstants} from "../../components.constants.js";

export default {
  props: ["selectedMetadataProfileId","selectedProfileKeyName"],
  data() {
    return {
      isProfileLoaded:false,
      selectedId:"",
      pInfoStatus:null,
      respFromAPI:null,
      reRenderPage:true,
      profileInfo: {
          "custom_metadata_id_list":[],
          "tag_id_list":[],
          "tag_display_all":false
      },
      isTagsEnabled:false,
      keyInfo: {
          "name": "",
          "custom_metadata_id_list":[],
          "tag_id_list":[],
          "tag_display_all":false
      },
      profileResp:null,
      fieldsInfo:{},
      enableFieldBrowser:false,
      enableTagBrowser:false,
      selectedTagIdNameMap:{},
      mainFieldKeyName:"",
      editedValue:""
    };
  },
  components:{
    "back-button":BackButton,
    "load-type-filter":LoadTypeFilter,
    "field-browser":FieldBrowser,
    "tag-browser":TagBrowser,
    "cancel-icon": CancelIcon,
    "edit-icon": EditIcon,
    "save-icon": SaveIcon,
  },
  computed:{
      currentProperties() {
        //Dynamically send props
        return {
             
         };
      }

  },
  methods : {
    handleBackNavigation(forceExit){
      let exitPage = true;
      if(!forceExit && this.mainFieldKeyName.length > 0){
        if(!confirm(
              `Unsaved data exists.\nYou will loose the edited data if exit from the page.`
            )){
            exitPage = false
          }
      }
      if(exitPage){
        this.selectedId = ""
        this.changeToSelectedMetadataProfileTableComponent('show-screen-profiles');
      }
    },
    editMainField(fieldKey){
      this.mainFieldKeyName = fieldKey
    },
    isMainEditting(fieldKey){
      return fieldKey == this.mainFieldKeyName;
    },
    handleFadePage(opacityVal){
      console.log("opacity",opacityVal);
      // this.$refs.fadeWhenModelOpen.style.opacity = opacityVal;
    },
    //field's operation
    handleFieldSelection(fieldIds, fieldIdNameMap){
          let updateTags = false;
          this.$refs.fadeWhenModelOpen.style.opacity = 1;
          if(fieldIds == undefined){
            this.enableFieldBrowser = false;
            return;
          }
          let fIdNameMap = {};
          Object.assign(fIdNameMap, fieldIdNameMap);
          for(let fieldId of fieldIds){
            if(!this.keyInfo.custom_metadata_id_list.includes(fieldId) && fieldId != "1"){
              this.keyInfo.custom_metadata_id_list.push(fieldId);
            }
          }
          this.enableFieldBrowser = false;
          if(fieldIds.includes("1")){
            updateTags = true;
            this.isTagsEnabled = true;
            this.keyInfo.tag_display_all = true;
          }
          this.updateCustomMetadata("custom_metadata_id_list",updateTags);
    },
    isFieldExists(fieldId){
      let idx = this.fieldsInfo.findIndex(item=>item._id == fieldId);
      if(idx >= 0){
        return true
      }
      return false
    },
    getCustomMetadataName(fieldInfo){
      if('language_alias_mapper' in fieldInfo && fieldInfo.language_alias_mapper && fieldInfo.language_alias_mapper.length > 0 && this.$i18n && this.$i18n.locale){
        let mapperExists = fieldInfo.language_alias_mapper.find(op=>op.code == this.$i18n.locale)
        if(mapperExists && Object.keys(mapperExists).length > 0 && mapperExists.field_alias && mapperExists.field_alias.length > 0){
          return mapperExists.field_alias;
        }
      }
      return fieldInfo.name;
    },
    getFieldNamefromId(fieldId){
        let filedDetails = this.fieldsInfo.filter(item=>item._id == fieldId);
        if(filedDetails.length > 0){
          return this.getCustomMetadataName(filedDetails[0]);
        }
        return "None";
    },
    removeField(fieldId){
          let updateTags = false;
          if(fieldId == "1"){
            this.isTagsEnabled = false;
            this.keyInfo.tag_display_all = false;
            this.keyInfo.tag_id_list = [];
            updateTags = true
          }
          if(this.keyInfo.custom_metadata_id_list.includes(fieldId)){
            this.keyInfo.custom_metadata_id_list.splice(this.keyInfo.custom_metadata_id_list.indexOf(fieldId),1);
          }
          this.updateCustomMetadata("custom_metadata_id_list", updateTags);
    },
    //

    //Tag id's operations
    handleTagSelection(tagIds, tagIdNameMap){
          this.$refs.fadeWhenModelOpen.style.opacity = 1;
          if(tagIds == undefined){
            this.enableTagBrowser = false;
            return;
          }
          let tIdNameMap = {};
          Object.assign(tIdNameMap, tagIdNameMap);
          for(let tagId of Object.keys(tIdNameMap)){
            if(!Object.keys(this.selectedTagIdNameMap).includes(tagId)){
              this.selectedTagIdNameMap[tagId] = tIdNameMap[tagId];
            }
          }
          for(let tagId of tagIds){
            if(!this.keyInfo.tag_id_list.includes(tagId)){
              this.keyInfo.tag_id_list.push(tagId);
            }
          }
          this.enableTagBrowser = false;
          this.updateCustomMetadata("tag_id_list");
    },
    getTagNamefromId(tagId){
          if(Object.keys(this.selectedTagIdNameMap).includes(tagId)){
            return this.selectedTagIdNameMap[tagId];
          }
          return "None";
    },
    removeTagId(tagId){
          if(this.keyInfo.tag_id_list.includes(tagId)){
            this.keyInfo.tag_id_list.splice(this.keyInfo.tag_id_list.indexOf(tagId),1);
          }
          this.updateCustomMetadata("tag_id_list");
    },
    updateTagDisplay(){
      this.keyInfo.tag_display_all = !this.keyInfo.tag_display_all;
      this.updateCustomMetadata("tag_display_all");
    },
    //
    changeToSelectedMetadataProfileTableComponent(compName, payload = {}){
        this.$emit("changeToSelectedMetadataProfileTableComponent", compName, payload)
    },
    updateCustomMetadata(field,updateTags = false){
        let payload = {}
        if(field == 'name'){
            if(this.keyInfo.name.trim().length <= 0){
                alert("Please add scrren profile name. ")
                document.getElementById("field_name").scrollIntoView();
                document.getElementById("name_value").focus();
                return
            }
            payload[field] = this.keyInfo.name.trim();
      }else if(field == "custom_metadata_id_list"){
        let idList = this.keyInfo[field];
        payload[field] = idList;
      }else {
        payload[field] = this.keyInfo[field];
      }
      if(updateTags){
        payload["tag_display_all"] = this.isTagsEnabled;
        payload["tag_id_list"] = this.keyInfo.tag_id_list;
      }
      payload.params = { _id: this.selectedId };
      this.updateExistingMetadataProfile(payload).then((data) => {
        if (Utils.isAcceptedStatusCode(data.statusCode)){
          this.$toast.success(data.message);
          this.profileInfo[field] = this.keyInfo[field];
        } else {
          this.$toast.error(data.message);
        }
        this.mainFieldKeyName='';
      });
    },
    refreshMetadataInfoPage(){
      let payload = {};
      payload.params = { _id: this.selectedId };
      this.getMetadataProfileInfoFromServer(payload).then((resp) => {
        this.keyInfo = resp.metadata_profile;
        Object.assign(this.profileInfo, resp.metadata_profile);
        for(let tInfo of resp.tag_info){
            this.selectedTagIdNameMap[tInfo.tag_id] = tInfo.name;
        }
        if((this.keyInfo.tag_id_list != undefined && this.keyInfo.tag_id_list.length > 0) || this.keyInfo.tag_display_all == true){
            this.isTagsEnabled = true;
        }
        if(this.profileResp){
          this.profileResp = resp
        }
        this.pInfoStatus.resolve(resp)
      });
    },
    refreshFieldsInfo(){
      if(Object.keys(this.getStartUpDataFromInCache()).includes("custom_metadatas")){
          this.fieldsInfo = this.getStartUpDataFromInCache()["custom_metadatas"];
      }
    },
    handleNotification(notification){
      notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
      let entry_info = notification.message
      if(notification.message){
        if([NotifierConstants.fieldCreatedNotification].includes(notification.message_type)){
          setTimeout(()=>{
            this.refreshFieldsInfo();
          }, 100);
        }else if([NotifierConstants.fieldModifiedNotification,
            NotifierConstants.fieldRemovedNotification].includes(notification.message_type)){
              if(this.keyInfo.custom_metadata_id_list.includes(entry_info.custom_metadata_id)){
                setTimeout(()=>{
                  this.refreshFieldsInfo();
                  this.refreshMetadataInfoPage();
                }, 100);
              }
        }else if(NotifierConstants.screenProfileModifiedNotification == notification.message_type){
          if(this.selectedId == entry_info.metadata_profile_id){
            this.reRenderPage = false;
            setTimeout(()=>{
                  this.refreshMetadataInfoPage();
                  this.reRenderPage = true;
            },1);
          }
        }else if(NotifierConstants.screenProfileRemovedNotification == notification.message_type){
          if(this.selectedId != undefined &&
             this.selectedId.length > 0 &&
             this.selectedId == entry_info.metadata_profile_id){
            this.$toast.info("' " + this.keyInfo.name + " ' screen profile is deleted by other user(s).");
            this.handleBackNavigation(true);
          }
        }
      }
    },
    ...mapGetters("startUpData",["getStartUpDataFromInCache"]),
    ...mapActions("metadataProfiles",["updateExistingMetadataProfile","getMetadataProfileInfoFromServer"]),
    ...mapMutations("websocket",["addWSEventListener", "removeWSEventListener"]),
  },
  created(){
    this.pInfoStatus = null;
    this.respFromAPI = new Promise((resolve, reject) =>{
          this.pInfoStatus = {resolve: resolve, reject: reject};
    });
    this.respFromAPI.then(res=>{
      if(res){
          this.profileResp = res;
      }
    });
    this.selectedId = this.selectedMetadataProfileId;
    this.refreshMetadataInfoPage();
    this.refreshFieldsInfo();
    this.addWSEventListener({
            eventname:[NotifierConstants.fieldCreatedNotification,
            NotifierConstants.fieldModifiedNotification,
            NotifierConstants.fieldRemovedNotification,
            NotifierConstants.screenProfileModifiedNotification,
            NotifierConstants.screenProfileRemovedNotification],
            callback:this.handleNotification,
            parent:"ScreenProfileInfoAddFieldsFromBrowser"})
  },
  beforeDestroy(){
    this.removeWSEventListener({
            eventname:[NotifierConstants.fieldCreatedNotification,
            NotifierConstants.fieldModifiedNotification,
            NotifierConstants.fieldRemovedNotification,
            NotifierConstants.screenProfileModifiedNotification,
            NotifierConstants.screenProfileRemovedNotification],
            callback:this.handleNotification,
            parent:"ScreenProfileInfoAddFieldsFromBrowser"})
  }
};
</script>


<style scoped lang="scss">
$table-row-border: none;
$active-blue: #007bff;
$danger-color: #dc3545;
$none-text-color:#4f4f4f;
$add-button-text-color:#0b7099;
$add-button-text-color-hover:#0193cc;
$add-button-border-color:#b7b228;
$add-button-border-on-hover:#dcd426;
$add-button-backgroud:#1e1e1e;
$active-green-color:#28a745;
$primary-background: #1a1e21;
$border-color: 1px solid #4a4a4a;
$primary-background: #1a1e21;
$secondary-background-color:#15181B;
$bg-color-on-hover: #22272b;
$text-color: #eee;
$dull-text-color: #757575;
$secondary-text-color: #9c9c9c;
$active-blue : #007bff;
$input-field-and-label-font-size:14px;
$input-field-height:38px;
$highlight-font-color:#ff9800;
$scrollbar-thumb-background:#333;
$scrollbar-track-background:#1a1e21;
$scrollbar-thumb-on-hover-background:#555; 
$input-field-padding:.375rem 10px;
$filter-border-color: #5a5a5a;
$filter-bg-color: #2a2a2a;
$learn-about-text-color-hover:#b7b327;
$learn-about-text-color:#9a9620;
$tags-background-color:#282d31;
$svg-color:#666;
$tags-border-color:#363636;
$secondary-border-color: 1px solid #2b2b2b;
$border-on-hover: 1px solid #61707d;




.editIcon {
  margin-inline-start: 9px !important;
}

.tags-display-ul .show-tags-delete {
  visibility: hidden;
}

.tags-display-ul li:hover .show-tags-delete {
  visibility: visible;
}
table.users-basic-info-table .editIcon {
  visibility: hidden;
}
table.users-basic-info-table td.value-div:hover .editIcon {
  visibility: visible;
}
.input-fields{
    border: none;
    border-radius: 0px !important;
}

// .input-fields:focus{
//     outline: unset;
//     border-bottom: 1px solid #0373ee !important;
// }

.upload-fields{
    border: $border-color;
    width: 46%;
    border-radius: 5px;
    position:relative;
}

.users-basic-info-table {
  font-size: $input-field-and-label-font-size;
  max-height:100%;
  tbody {
    margin: 10px;
    .key-div {
      text-align: end;
      color: $secondary-text-color;
      border:none;
      line-height:39px;
      font-size:16px;
    }
    .value-div {
      text-align: start;
      margin-inline-start: 10px !important;
      border:none;
    }
  }
}
table {
  background: transparent;
  thead {
    th {
      color: $dull-text-color;
      padding:0px !important;
      border:none;
    }
  }
  tbody {
    color: $text-color;
    padding:0px !important;
    border:none;
  }
  th{
      padding:0px !important;
  }
}

.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}

.view-tags {
    font-size: 12px!important;
    display: inline-flex!important;
    margin: 6px!important;
    border-radius: 15px!important;
    text-align: start;
    padding: 7px!important;
    justify-content: space-between;
    background:$primary-background;
    border:$border-color;
  span {
    margin-inline-start: 0px !important;
    font-size: 12px !important;
    border-radius: 15px !important;
    position: relative !important;
    top: 1px !important;
    width: 90%;
  }
}

.drag-icon{
  color:$dull-text-color;
  cursor: grab;
}

.editIcon {
  margin-inline-start: 9px;
}

.view-tags:hover, .view-sub-tags:hover {
  border: $border-on-hover !important;
}

.view-tags .show-main-tag-delete, .more-actions-btn {
  visibility: hidden;
}

.view-tags:hover{
  .show-main-tag-delete, .more-actions-btn {
    visibility: visible;
  }
} 
.show-tags-delete{
  visibility: hidden;
}

.view-sub-tags:hover .show-tags-delete{
  visibility: visible;
}

.show-main-tag-delete {
  margin-inline-start: 5px;
  margin-inline-end: 5px;
}

.custom-control-label::before {
  background-color: $primary-background;
}

.validationmessage {
  color: $danger-color;
  font-size: 11px;
}

/* width */
::-webkit-scrollbar {
  width: 8px;
}

/* Track */
::-webkit-scrollbar-track {
  background: $scrollbar-track-background;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: $scrollbar-thumb-background;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: $scrollbar-thumb-on-hover-background;
}

input[type="checkbox"]:after {
    line-height: 1.5em;
    content: "";
    display: inline-block;
    width: 20px;
    height: 19px;
    margin-top: 0px;
    margin-inline-start: -1px;
    border: $border-color;
    border-radius: .25em;
    background: $primary-background;
}

input[type="checkbox"]:checked:after {
  content: "✔";
  color: $active-blue;
  position: absolute;
  font-size: 16px;
  line-height: 1;
  transition: all 0.2s;
  font-family: Helvetica, Arial, sans-serif;
  padding-inline-start: 4px;
  padding-top: 2px;
}

.breadcrumb{
  padding: .75rem 1rem !important;
  background: $primary-background !important;
  align-items: center;
    .active-text-nav-bar{
        color: $text-color !important;
        text-decoration: none !important
    }
    .active-text-nav-bar:last-child{
            color: $active-blue !important;
            font-size:17px;
    }
    .breadcrumb-item{
        a{
            color: $text-color;
            font-weight:600;
        }
        a:hover{
            text-decoration: underline;
        }
    }    
}

.secondary-btn-style:hover{
  text-decoration: underline;
}
.secondary-btn-style{
  color:$text-color;
}

.screen-tags-name-display{
  display:inline-flex;
  line-height:44px;
  width:33%;
}

.screen-tags-styles{
  display:inline-flex;
  .view-sub-tags{
    font-size: 12px!important;
    height: 30px;
    display: inline-flex!important;
    margin: 5px!important;
    border: $border-color!important;
    border-radius: 15px!important;
    min-width: 50px!important;
    padding: 0!important;
    text-align: start;
    width: auto!important;
    padding-inline-start: 12px!important;
    justify-content: start;
    padding-top: 2px!important;
    span {
      margin-inline-start: 0!important;
      font-size: 12px!important;
      border-radius: 15px!important;
      position: relative!important;
      top: 3px!important;
      width: 90%;
    }
    .show-tags-delete{
      margin: 3px!important;
      float: inline-end;
      text-align: end;
      width: 25px;
      height: 25px;
      color: $text-color;
      position: relative;
      bottom: 4px;
    }
  }
}

.screens-name-styles{
    width: 200px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.tags-display-ul{
  list-style-type: none;
}

.add-screens-styles{
    display: inline-flex;
    height: 57px;
    border: 1px solid $add-button-border-color;
    border-radius: 10px;
    width: 97%;
    margin-block: 8px;
    margin-inline: 0;
    justify-content: center;
    line-height: 52px;
    color:$add-button-text-color;
}

.add-screens-styles:hover{
    border: 1px solid $add-button-border-on-hover;
    color:$add-button-text-color-hover;
}

.comm-input-field-style{
    background: $primary-background!important;
    width: 100% !important;
    float: inline-start;
    padding: $input-field-padding;
    border: $border-color!important;
    font-size:$input-field-and-label-font-size;
    height: $input-field-height;
}

.align-input-field{
  margin-top:-8px;
}

table {
  background: transparent;
  thead {
    th {
      color: $dull-text-color;
    }
  }
  tbody {
    color: $text-color;
  }
}

.show-main-tag-delete {
  margin-inline-start: 5px;
  margin-inline-end: 5px;
}

.view-tags .show-main-tag-delete, .more-actions-btn {
  visibility: hidden;
}

.view-tags:hover{
  .show-main-tag-delete, .more-actions-btn {
    visibility: visible;
  }
}

.editIcon {
  margin-inline-start: 9px;
}

.view-tags:hover {
  border: $border-on-hover !important;
}

.tags-display-ul .show-tags-delete {
  visibility: hidden;
}

.tags-display-ul li:hover .show-tags-delete {
  visibility: visible;
}

.show-tags-delete {
  margin-inline-start: 1px;
  margin-inline-end: 5px;
}

.btn {
  font-size: 14px !important;
  height: 100%;
}

.border {
  border: $border-color !important;
}

.primary-btn-style {
  margin-top: 1%;
  position: absolute;
  inset-inline-end: 23%;
  button {
    height: 35px;
    width: 70px;
    font-size:14px;
  }
}

label{
    position: relative;
    bottom: 4px;
    inset-inline-start:2px;
}

.searched-metadata-display-fields{
  height: auto;
  width: 82%;
  overflow:auto;
}

.set-height-of-div{
  height: calc(100vh - 145px);
  overflow:auto;
  position:relative;
  top:20px;
}

.list-group-item {
  width:97%;
}

.activeClass{
  color:$active-blue;
}
</style>